/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/feature/prototype/fillet 层；
 * 2. 负责定义圆角特征原型对象；
 * 3. 该原型对象是设计树、编辑会话与结果对象共享的圆角领域入口。
 *
 * 文件职责：
 * 1. 统一承载圆角定义对象、输入绑定与来源对象；
 * 2. 为编辑、预览和设计树提供稳定领域对象；
 * 3. 避免上层继续直接依赖原始命令参数。
 */

import type { FeatureReferenceBinding } from '../../binding/FeatureReferenceBinding';
import { FilletFeatureDefinitionModel } from '../../definition/fillet/FilletFeatureDefinition';
import { FeaturePrototype } from '../FeaturePrototype';

/**
 * 圆角特征原型。
 */
export class FilletFeaturePrototype extends FeaturePrototype<FilletFeatureDefinitionModel> {
    /**
     * @param input 输入参数。
     */
    public constructor(input: {
        featureId: string;
        definition: FilletFeatureDefinitionModel;
        bindings: FeatureReferenceBinding[];
        sourceSketchId?: string | null;
    }) {
        super(input);
    }
}
